import { createAction, props } from '@ngrx/store';

export const setApplianceCategory = createAction(
  '[Catalog] Set appliance category',
  props<{ category: string }>()
);

export const setApplianceType = createAction(
  '[Catalog] Set appliance type',
  props<{ code: string }>()
);
